<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    document.body.classList.remove('fade-out')
  }
}
</script>

<style lang="scss">
@import 'src/assets/scss/reset.scss';
@import 'src/assets/scss/main.scss';
</style>
